class ExperimentToggleStore {
  constructor() {
    this.experimentToggleStore = {}
  }

  merge(object) {
    if (object) {
      this.experimentToggleStore = { ...this.experimentToggleStore, ...object }
    }
  }

  on(key) {
    return this.experimentToggleStore[key] === true
  }
}

const experiments = new ExperimentToggleStore()

export default experiments
